import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Error from '../../Error';
import Loading from '../../Loading';
import useFindActivityFields from '../../../hooks/activity-fields/find-activity-fields.hook';
import useFindUserBooking from '../../../hooks/bookings/find-user-booking.hook';
import useFindUserDetailedSheet from '../../../hooks/detailed-sheets/find-user-detailed-sheet.hook';
import useFindUserMostRecentDetailedSheet from '../../../hooks/detailed-sheets/find-user-most-recent-detailed-sheet.hook';
import useFindActiveEdition from '../../../hooks/editions/find-active-edition.hook';
import useFindUserProfile from '../../../hooks/profiles/find-user-profile.hook';

const EditDetailedSheetContainer: FC = () => {
  const { data: edition, status: editionStatus } = useFindActiveEdition();
  const { data: profile, status: profileStatus } = useFindUserProfile();
  const { data: booking, status: bookingStatus } = useFindUserBooking();

  const { data: activityFields, status: activityFieldsStatus } =
    useFindActivityFields({ take: 1000 });

  const { data: detailedSheet, status: detailedSheetStatus } =
    useFindUserDetailedSheet();

  const {
    data: mostRecentDetailedSheet = null,
    status: mostRecentDetailedSheetStatus,
  } = useFindUserMostRecentDetailedSheet();

  if (
    activityFieldsStatus === 'loading' ||
    bookingStatus === 'loading' ||
    detailedSheetStatus === 'loading' ||
    editionStatus === 'loading' ||
    mostRecentDetailedSheetStatus === 'loading' ||
    profileStatus === 'loading' ||
    activityFieldsStatus === 'idle' ||
    bookingStatus === 'idle' ||
    detailedSheetStatus === 'idle' ||
    editionStatus === 'idle' ||
    mostRecentDetailedSheetStatus === 'idle' ||
    profileStatus === 'idle'
  ) {
    return <Loading />;
  }

  if (
    activityFieldsStatus === 'error' ||
    bookingStatus === 'error' ||
    detailedSheetStatus === 'error' ||
    editionStatus === 'error' ||
    mostRecentDetailedSheetStatus === 'error' ||
    profileStatus === 'error'
  ) {
    return <Error />;
  }

  return (
    <Outlet
      context={{
        activityFields,
        detailedSheet,
        edition,
        mostRecentDetailedSheet,
        profile,
        booking,
      }}
    />
  );
};

export default EditDetailedSheetContainer;
